
import '../templates/shipmentShippingInfo.scss';

import { TransportMode} from '../../../../requestList/models/transportMode';
import { ITransportModeService } from '../../../../requestList/services/transportModeService';
import { RequestDetailEdit } from '../../../models/requestDetailEdit';

export class ShipmentShippingInfoController implements ng.IController {
   
    private _transportModes: TransportMode[];
    static $inject = ['transportModeService'];
    requestDetailEdit: RequestDetailEdit;
    isConsigneeSearchLoading: boolean;
    isConsigneeSearchValid: boolean;
    
    minDate: Date;
    minDateToDisableDeliveryDate : Date;
    constructor(private _transportModeService: ITransportModeService) {
    }

    $onInit() {
        this._transportModeService.getTransportModes().then(o => this.handleGetTransportModes(o));
        this.minDate = new Date();
        this.minDate.setDate(this.minDate.getDate() - 29);
        this.minDate.setHours(0, 0, 0, 0);

        this.minDateToDisableDeliveryDate = new Date();
        this.minDateToDisableDeliveryDate.setDate(this.minDateToDisableDeliveryDate.getDate() - 30);
        this.minDateToDisableDeliveryDate.setHours(0, 0, 0, 0);
    }

    private handleGetTransportModes(options: TransportMode[]) {
        this._transportModes = options;
    }

    get transportModes(): TransportMode[] {
        return this._transportModes;
    }

    setMaxShipReadyDate() {
        if (this.requestDetailEdit !== undefined &&
            this.requestDetailEdit.requestDetail !== undefined &&
            this.requestDetailEdit.requestDetail.requestShipment !== undefined &&
            this.requestDetailEdit.requestDetail.requestShipment.requestedDeliveryDate !== undefined) {
            this.requestDetailEdit.requestDetail.requestShipment.maxShipmentReadyDate =
                angular.copy(this.requestDetailEdit.requestDetail.requestShipment.requestedDeliveryDate);
            this.requestDetailEdit.requestDetail.requestShipment.maxShipmentReadyDate.
                setDate(this.requestDetailEdit.requestDetail.requestShipment.maxShipmentReadyDate.getDate() - 1);
        }
    }


    get isLoading(): boolean {
        return this.isConsigneeSearchLoading;
    }

    set isLoading(val : boolean) {}

    
    shipmentShippingInfoForm: ng.IFormController;
    contactForm: ng.IFormController;
    assetForm: ng.IFormController;

    get isValid(): boolean {
        return this.isConsigneeSearchValid && (this.shipmentShippingInfoForm ? this.shipmentShippingInfoForm.$valid : false) && (this.contactForm ? this.contactForm.$valid : false) &&
            this.isTransportModeLtlValid;
    }

    set isValid(val: boolean) { }


    isChargeToConsigneeEnabled(val: string): boolean {
        return (val === "Yes");
    }
    onChargetoConsigneeChange() {
        if (this.shipmentNotUndefined() &&
            this.requestDetailEdit.requestDetail.requestShipment.additionalFreightCharges !== undefined) {
            this.requestDetailEdit.requestDetail.requestShipment.additionalFreightCharges = undefined;
            this.requestDetailEdit.requestDetail.requestShipment.additionalPackagingFees = undefined;
        }
    }

    isFAMREnabled(val: string): boolean {
        return (val === "Yes");
    }

    isAssetOnChange(): void {
        if (this.requestDetailEdit.requestDetail.requestShipment.isAssetValue === "No") {
            this.requestDetailEdit.requestDetail.requestShipment.isFAMRValue = "No";
        }
    }

    isConsigneeParameterHasValue(consigneeeParameter: string): boolean {
        return (consigneeeParameter !== undefined && consigneeeParameter !== null && consigneeeParameter.length > 0);
    }
    requestedDateDisabled(): boolean {
       
        if (this.requestDetailEdit !== undefined && this.requestDetailEdit.requestDetail !== undefined &&
            this.requestDetailEdit.requestDetail.requestShipment !== undefined &&
            this.requestDetailEdit.requestDetail.requestShipment.shipmentReadyDate !== undefined &&
            this.requestDetailEdit.requestDetail.requestShipment.shipmentReadyDate < this.minDateToDisableDeliveryDate)
            return true;
        else {
            return false;
        }
    }
    getTransportModeIcon(transportModeVal: string): string {
        if (!transportModeVal)
            return '';

        if (transportModeVal.toUpperCase().toString().trim() === 'LTL')
            return 'airport_shuttle';
        else if (transportModeVal.toUpperCase().toString().trim() === 'TRUCK')
            return 'local_shipping';
        else if (transportModeVal.toUpperCase().toString().trim() === 'OCEAN')
            return 'directions_boat';
        else if (transportModeVal.toUpperCase().toString().trim() === 'AIR')
            return 'flight';
        else if (transportModeVal.toUpperCase().toString().trim() === 'EXPRESS')
            return 'star';
        else if (transportModeVal.toUpperCase().toString().trim() === 'EXPRESS OR LTL')
            return 'star';
        return '';
    }

    shipmentNotUndefined(): boolean {
        return this.requestDetailEdit !== undefined &&
            this.requestDetailEdit.requestDetail !== undefined &&
            this.requestDetailEdit.requestDetail.requestShipment !== undefined;
    }

    consigneeNotUndefined(): boolean {
        return this.requestDetailEdit !== undefined &&
            this.requestDetailEdit.requestDetail !== undefined &&
            this.requestDetailEdit.requestDetail.requestConsignee !== undefined;
    }

    get isTransportModeLtlValid(): boolean {
        if (this.shipmentNotUndefined() && this.consigneeNotUndefined() &&
            this.requestDetailEdit.requestDetail.requestShipment.transportMode !== undefined &&
            this.requestDetailEdit.requestDetail.requestConsignee.countryCode !== undefined &&
            this.requestDetailEdit.requestDetail.requestShipment.transportMode.toUpperCase() === "LTL") {
            var countryCode = this.requestDetailEdit.requestDetail.requestConsignee.countryCode.toUpperCase();
            if (countryCode === "US" ||
                countryCode === "CA" ||
                countryCode === "PR") {
                return true;
            } else {
                return false;
            }
        }
        return true;
    }

    getPopupText(transportationMode): string {
        if (transportationMode === 'Air')
            return 'This option is for shipments that can’t be shipped through the mail center and aren’t large enough or are too time sensitive for Ocean -Global Distribution Group will manage these requests';
        else if (transportationMode === 'Express')
            return 'This option is for documents or small packages that can be shipped via Express like FedEx, UPS, or DHL -Mail Center will manage most of these requests';
        else if (transportationMode === 'LTL')
            return 'This option is for palletized shipments that are less than 10,000kg for USA to USA, USA to Canada, or USA to Mexico with a standard trucking delivery timeline';
        else if (transportationMode === 'Ocean')
            return 'This option is for palletized or equipment shipments that we have enough lead time to meet the delivery timeline -Global Distribution Group will manage these requests';
        else if (transportationMode === 'Truck')
            return 'This option is generally for palletized shipments that are greater than 10,000kg with destinations of USA, Canada, or Mexico -Global Distribution Group will manage these requests';
        else if (transportationMode === 'Express or LTL')
            return 'Express or LTL';
    }

}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestDetailEdit/directives/shipmentShippingInfo/controllers/shipmentShippingInfoController.ts
 **/